import { createSlice } from '@reduxjs/toolkit';

import {
  type IEmailValidatorState,
  type IEmailValidatorVerify,
  type IEmailValidatorVerifyResponse,
  type IEmailValidatorVerifyTimeout,
} from './types';

const initialState: IEmailValidatorState = {
  entries: {},
};

const emailValidatorSlice = createSlice({
  name: 'EmailValidator',
  initialState,
  reducers: {
    emailValidatorVerify: (state, action: IEmailValidatorVerify): void => {
      state.entries[action.payload.correlationId] = {
        email: action.payload.email,
        isLoading: true,
      };
    },
    emailValidatorVerifyResponse: (
      state,
      action: IEmailValidatorVerifyResponse,
    ): void => {
      const { result } = action.payload;

      if (!result.correlationId) {
        return;
      }

      state.entries[result.correlationId] = {
        email: state.entries[result.correlationId]?.email ?? result.email,
        isLoading: false,
        result,
      };
    },
    emailValidatorVerifyTimeout: (
      state,
      action: IEmailValidatorVerifyTimeout,
    ): void => {
      state.entries[action.payload.correlationId] = {
        email: action.payload.email,
        isLoading: false,
        timedOut: true,
      };
    },
  },
});

export const {
  emailValidatorVerify,
  emailValidatorVerifyResponse,
  emailValidatorVerifyTimeout,
} = emailValidatorSlice.actions;

export default emailValidatorSlice.reducer;
